// extracted by mini-css-extract-plugin
export default {"status":"Status_status__fahxy","pending":"Status_pending__qbBzy","approved":"Status_approved__0Dt3W","rejected":"Status_rejected__AUYfk","flagged":"Status_flagged__Xjlq9"};